import { Injectable } from '@angular/core';
import { SocketManagerProvider } from '../socket-manager/socket-manager';
import { StorageManagerProvider } from '../storage-manager/storage-manager';
import { Collection } from '../../bayadic-shared-models/collection/Collection'
import { AlertController } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';
import { Events } from '../../providers/events/events';
import { GetCollectionsResponse } from '../../bayadic-shared-models/collection/get-collections-response';


@Injectable()
export class CollectionsManagerProvider {
  loadCollectionsFromTemplate(): GetCollectionsResponse{
    return {
      collections: [
          new Collection({
            lang:"fa",
            name:"dictionary",
            localCount:0,
            subItems: [],
            cost:0,
            title: 'Dictionary',
            titleFa: 'واژه نامه',
            titleDe: 'Wörterbuch',
            type: 'dictionary',
            itemType: 'dictionary',
            description: 'Dictionary is an item, that lets you add your words into this item. Each word will be translated automatically.You can also share this item with you friends. If you like, the item can be renamed to a lesson of your book. Then you can add all the words of that lesson into this item and share it with your class mates',
            descriptionDe: 'Wenn du ein Wörterbuch brauchst, kannst das Item in deinem List hinzufügen. Das Item kannst du auch mit den Freunden verteilen',
            descriptionFa: 'با اضافه کردن این ویژگی به لیست امکاناتتون می تونید لغت های آلمانی به فارسی رو ترجمه کنید. واژه نامه لغت هاتون رو داخل خودش ذخیره هم می کنه و بعدا می تونید  اون ها رو مرور کنید',
            content: '{"en":{"description":"Dictionary is an item, that lets you to add you words in to this item. Each words will be translated automatically.You can also share this item with you friends. If you like, the item can be renamed to a lesson of your book. Then you can add all the words of that lesson into this item and share it with your class mates","title":"Dictionary"},"fa":{"description":"دیکشنری این اجازه رو به شما می دهد که هر لغتی را درون این آیتم وارد کنید.لغت ها به صورت خودکار ترجمه می شوند و شما می توانید از امکانات یک مترجمه استفاده کنید.","title":"دیکشنری"},"de":{"description":"Wenn du ein Wörterbuch brauchst, kannst das Item in deinem List hinzufügen. Das Item kannst du auch mit den Freunden verteilen","title":"Wörterbuch"}}'
          }, 'fa'),
          new Collection({
            title: 'Leitner',
            lang:'fa',
            titleFa: 'جعبه لایتنر',
            titleDe: 'Leitner',
            type: 'leitner',
            itemType: 'leitner',
            cost:0,
            description: 'The best way to learn the words is to practice them every period of time, if you have this item in your list, you can add your words there and it helps you to review them like your flash cards. After 5 time you will be master of the card',
            descriptionDe: 'The best way to learn the words is to practice them every period of time, if you have this item in your list, you can add your words there and it helps you to review them like your flash cards. After 5 time you will be master of the card',
            descriptionFa: 'برای یادگیری و ثبت واژگان در حافظه ی بلند مدت روش های مختلفی وجود داره. رایج ترین اون ها استفاده از فلش کارت هست. جعبه لایتنر مخصوص همین کار هست. شما می تونید لغت هاتون رو از واژه نامه به جعبه ی لایتنر برای یادآوری اضافه کنید',
          }, 'fa'),
          new Collection({
            title: 'Quiz',
            lang:'fa',
            titleFa: 'کوییز',
            titleDe: 'Quiz',
            type: 'quiz',
            itemType: 'quiz',
            cost:0,
            description: 'Test your knowledge with interactive quizzes. Create custom quizzes with multiple choice questions and track your progress.',
            descriptionDe: 'Testen Sie Ihr Wissen mit interaktiven Quizfragen. Erstellen Sie benutzerdefinierte Quizfragen mit Multiple-Choice-Fragen und verfolgen Sie Ihren Fortschritt.',
            descriptionFa: 'دانش خود را با آزمون های تعاملی محک بزنید. آزمون های سفارشی با سوالات چند گزینه ای ایجاد کنید و پیشرفت خود را پیگیری کنید.',
          }, 'fa')
      ]
    }
  }
  getInstanceOfDictionary(): Collection {
    return new Collection({ collectionType: Collection.typeDictionary })
  }
  public collections: Array<Collection> = [];
  public collectionStorageName: string = "collectionStorage";
  public lang: string = "fa";
  loading: boolean = false;
  constructor(
    public socketManager: SocketManagerProvider,
    public storageManager: StorageManagerProvider,
    public alertCtrl: AlertController,
    public events: Events,
    private translateService: TranslateService) {
      this.init();
  
  }
  async init() {
    const lang = await this.storageManager.get("lang")
    if(lang) this.lang = lang

    await this.loadCollections();
  }

  changeLanguage(lang: any) {
    for (let collection of this.collections) {
      collection.setLang(lang);
    }
  }
  async save() {
    await this.storageManager.set(this.collectionStorageName, this.collections);
  }
  async loadCollections() {
    if (this.loading) {
      return false;
    }
    if (this.collections.length > 0) return false;
    this.loading = true;
    if (this.collections.length === 0) {
      this.collections =  this.loadCollectionsFromTemplate().collections;
    }
    this.loading = false;
    await this.save();
  }
  async getLang(){
    if(this.lang) return this.lang;
    else return await this.storageManager.get("lang");
  }
  async loadCollectionsFromInternet(): Promise<Collection[]> {
    const collections = [];
    const response = this.loadCollectionsFromTemplate();
    const lang = await this.getLang()
    for (let collectionObject of response.collections) {
      const collection = new Collection(collectionObject, lang);
      collection.setLang(lang);
      collections.push(collection);
    }
    return collections;
  }

  addConfirm(collection: Collection) {
    let title: string;
    this.translateService.get("TITLE.confirm").subscribe(
      value => {
        title = value;
      }
    );
    let cancelBtnText: string;
    this.translateService.get("BUTTONS.cancel").subscribe(
      value => {
        cancelBtnText = value;
      }
    );
    let yesBtnText: string;
    this.translateService.get("BUTTONS.yes").subscribe(
      value => {
        yesBtnText = value;
      }
    );
    let message: string;
    this.translateService.get("CONTENT.Collection.addMessage").subscribe(
      value => {
        message = value;
      }
    );

    return new Promise(async (resolve, reject) => {
      let alert = await this.alertCtrl.create({
        subHeader: title,
        message: message,
        buttons: [
          {
            text: cancelBtnText,
            role: 'cancel',
            handler: () => {
              resolve(false);
              //                this.logger.debug('Cancel clicked');
            }
          },
          {
            text: yesBtnText,
            handler: () => {
              resolve(true);
              //                this.logger.debug('Buy clicked');
            }
          }
        ]
      });
      alert.present();
    });
  }

}
